import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f9691eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OUsuarioInformacoes",
  "data-testid": "OUsuarioInformacoes"
}
const _hoisted_2 = { class: "OUsuarioInformacoes__ColunaFoto" }
const _hoisted_3 = { for: "Input__Avatar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "OUsuarioInformacoes__SobreposicaoFoto" }, [
  /*#__PURE__*/_createElementVNode("em", { class: "pi pi-pencil" })
], -1))
const _hoisted_5 = { class: "OUsuarioInformacoes__ColunaInputs" }
const _hoisted_6 = { class: "OUsuarioInformacoes__LinhaInputs" }

import { computed, onMounted, ref } from "vue"

  import Avatar from "primevue/avatar"
  import { MInput } from "@/components/Gerais"

  import { helpers, required } from "@vuelidate/validators"
  import useVuelidate from "@vuelidate/core"

  import { EntidadeGenerica } from "@/types/gerais"

  import * as avatarImg from "@/assets/pi-avatar.png"

  import UsuariosRepositorio from "@/repositorios/usuarios/usuarios.repositorio"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import {
    ListarUsuarios,
    ParamsUsuario,
  } from "@/repositorios/usuarios/usuarios.modelo"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import { useI18n } from "vue-i18n"

  export interface IEmitirEventoNomeCodigoProps {
    nome: string
    codigo: string
  }

  interface Props {
    nome: string
    codigo: string
    fotoUrl?: string | null
    usuariosResponsaveis: string[]
    temUsuariosResponsaveis?: boolean
    escopoValidacao?: string
    teleportarPara?: "self"
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OUsuarioInformacoes',
  props: {
    nome: null,
    codigo: null,
    fotoUrl: { default: avatarImg },
    usuariosResponsaveis: null,
    temUsuariosResponsaveis: { type: Boolean },
    escopoValidacao: null,
    teleportarPara: null
  },
  emits: ["update:nome", "update:codigo", "update:fotoUrl", "update:foto", "update:usuariosResponsaveis"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:nome", nome: string): void
    (event: "update:codigo", codigo: string): void
    (event: "update:fotoUrl", foto: string): void
    (event: "update:foto", foto: File): void
    (event: "update:usuariosResponsaveis", usuariosResponsaveis: string[]): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { nome: string, codigo: string, fotoUrl: string | null, usuariosResponsaveis: string[], temUsuariosResponsaveis?: boolean, escopoValidacao?: string, teleportarPara?: "self" }

  

  

  const { t } = useI18n()

  const usuariosRep = new UsuariosRepositorio()

  const { colher } = usarManipuladorObjetos()
  const { leitor } = usarLeitorDeDados()

  const lerUsuariosResponsaveis = leitor<ListarUsuarios, ParamsUsuario>(
    usuariosRep.listarUsuarios,
    {}
  )

  const atualizaFoto = (event: any): void => {
    const [imagem] = event.target.files || []

    if (!imagem) {
      return
    }
    emitir("update:foto", imagem)

    modelFoto.value = URL.createObjectURL(imagem)
  }

  const modelNome = computed({
    get() {
      return props.nome
    },
    set(nome: string) {
      emitir("update:nome", nome)
    },
  })
  const modelFoto = computed({
    get() {
      return props.fotoUrl
    },
    set(fotoUrl: string) {
      emitir("update:fotoUrl", fotoUrl)
    },
  })
  const modelCodigo = computed({
    get() {
      return props.codigo
    },
    set(codigo: string) {
      emitir("update:codigo", codigo)
    },
  })
  const regras = {
    nome: {
      obrigatorio: helpers.withMessage(t("campoObrigatorio"), required),
    },
    codigo: {
      obrigatorio: helpers.withMessage(t("campoObrigatorio"), required),
    },
  }

  const v$ = useVuelidate(
    regras,
    { nome: modelNome, codigo: modelCodigo },
    { $scope: props.escopoValidacao }
  )
  const responsaveis = ref<EntidadeGenerica[]>([])

  onMounted(async () => {
    await lerUsuariosResponsaveis.porPagina(1000).executar()

    if (lerUsuariosResponsaveis.resultado.status === "sucesso") {
      responsaveis.value = colher<ListarUsuarios, { id: string; nome: string }>(
        lerUsuariosResponsaveis.resultado.dados,
        ["id", "nome"]
      )
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _createVNode(_unref(Avatar), {
          class: "OUsuarioInformacoes__FotoUsuario",
          image: _unref(modelFoto) || avatarImg,
          shape: "circle",
          size: "xlarge"
        }, null, 8, ["image"]),
        _hoisted_4
      ]),
      _createElementVNode("input", {
        onChange: _cache[0] || (_cache[0] = ($event: any) => (atualizaFoto($event))),
        id: "Input__Avatar",
        accept: "image/jpeg, image/png, image/jpg",
        "data-testid": "OUsuarioInformacoes__EntradaDeFoto",
        hidden: "",
        type: "file"
      }, null, 32)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(MInput), {
          modelValue: _unref(v$).nome.$model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).nome.$model) = $event)),
          class: _normalizeClass(["OUsuarioInformacoes__Nome", { 'p-invalid': _unref(v$).nome.$invalid }]),
          "data-testid": "OUsuarioInformacoes__Nome",
          label: _unref(t)('nome'),
          "mensagem-de-erro": _unref(v$).nome.$errors[0]?.$message,
          nome: "nome",
          obrigatorio: "",
          "retirar-caractere-especial": "",
          "tipo-entrada": "text"
        }, null, 8, ["modelValue", "class", "label", "mensagem-de-erro"]),
        _createVNode(_unref(MInput), {
          modelValue: _unref(v$).codigo.$model,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).codigo.$model) = $event)),
          class: _normalizeClass(["OUsuarioInformacoes__Codigo", { 'p-invalid': _unref(v$).codigo.$invalid }]),
          "data-testid": "OUsuarioInformacoes__Codigo",
          label: ('codigo'),
          "mensagem-de-erro": _unref(v$).codigo.$errors[0]?.$message,
          nome: "codigo",
          obrigatorio: "",
          "tipo-entrada": "text"
        }, null, 8, ["modelValue", "class", "label", "mensagem-de-erro"])
      ])
    ])
  ]))
}
}

})